import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const removeUndeclaredItemFromProcessingSession = {
  name: "removeUndeclaredItemFromProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    sessionItemId: processingSessionItemIdFormat.schema,
  }),
  output: z.object({ session: ProcessingSession }),
};
